/* dcta-events-page.js - Events page: month calendar + location picker.
   (c) Dot Com Technologies (dotcomtek.com) */
(function () {
  var root = document.getElementById('DctaEvp');
  if (!root) return;

  var MON = ['January','February','March','April','May','June','July',
             'August','September','October','November','December'];
  var MS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var XMAP = { 'glen mills': 'glen-eagle', 'northfield': 'allens-shoes', 'manhattan': 'manhattan' };

  function J(id) { var e = document.getElementById(id); try { return e ? JSON.parse(e.textContent) : null; } catch (x) { return null; } }
  function z(n) { return (n < 10 ? '0' : '') + n; }
  function esc(t) { return (t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function D(iso) { if (!iso) return null; var t = iso.length > 10 ? new Date(iso) : new Date(iso + 'T00:00:00'); return isNaN(t) ? null : t; }
  function slugStore(lbl) {
    var base = (lbl || '').split(',')[0].split(' - ')[0].trim().toLowerCase();
    return XMAP[base] || base.replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-');
  }
  function midnight(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

  var BRANDS = J('EvpBrands') || {};
  var STORES = J('EvpStores') || [];
  var MULTI = root.getAttribute('data-multi') === '1';

  /* ---- events ---- */
  var EV = [];
  var blocks = document.querySelectorAll('script.evp-data');
  for (var i = 0; i < blocks.length; i++) {
    var bk = blocks[i].getAttribute('data-brand'), arr = [];
    try { arr = JSON.parse(blocks[i].textContent) || []; } catch (x) { arr = []; }
    for (var j = 0; j < arr.length; j++) { arr[j].brand = bk; EV.push(arr[j]); }
  }
  var evs = EV.map(function (r) {
    var sd = D(r.start), ed = D(r.end) || D(r.start);
    if (r.allDay && ed) ed = new Date(ed.getTime() - 86400000); /* gcal end is exclusive */
    if (!sd) return null;
    if (!ed || ed < sd) ed = sd;
    var st = STORES.filter(function (s) { return s.l === r.store; })[0];
    return {
      t: r.title || '', l: r.store || '', d: r.desc || '', b: r.brand,
      h: st ? st.h : slugStore(r.store), disp: (st && st.d) ? st.d : (r.store || ''),
      st: st || null,
      sd: sd, ed: ed, ad: !!r.allDay,
      gs: new Date(sd.getTime() + 43200000), ge: new Date(ed.getTime() + 43200000)
    };
  }).filter(Boolean);
  var seen = {};
  evs = evs.filter(function (e) {
    var k = e.b + '|' + e.h + '|' + e.t.toLowerCase().replace(/[^a-z0-9]/g, '') + '|' + e.sd.getTime();
    if (seen[k]) return false; seen[k] = 1; return true;
  });
  evs.sort(function (a, b) { return a.sd - b.sd; });

  /* ---- picker ---- */
  var sel = document.getElementById('EvpLoc');
  var present = {}; evs.forEach(function (e) { present[e.b] = 1; });
  var order = Object.keys(BRANDS);
  function addOpt(parent, s) {
    var o = document.createElement('option');
    o.value = s.h; o.textContent = s.d || s.l; parent.appendChild(o);
  }
  var FOCUS = root.getAttribute('data-brand') || order[0];
  /* focus brand first; every group is led by an all-of-this-brand option.
     There is deliberately no family-wide "all locations" choice. */
  order.sort(function (a, b) { return (a === FOCUS ? -1 : 0) - (b === FOCUS ? -1 : 0); });
  order.forEach(function (bk) {
    var list = STORES.filter(function (s) { return s.b === bk; });
    if (!list.length) return;
    var bn = (BRANDS[bk] || {}).n || bk;
    var parent = sel;
    if (MULTI) { parent = document.createElement('optgroup'); parent.label = bn; }
    list.forEach(function (s) { addOpt(parent, s); });
    if (MULTI) sel.appendChild(parent);
  });

  /* ---- state (deep-linkable: ?loc=handle#YYYY-MM) ---- */
  var qs = new URLSearchParams(location.search);
  /* Default: the brand in focus - its first store with upcoming events,
     else its first store. No family-wide or brand-wide "all" option. */
  function defaultLoc() {
    var mine = STORES.filter(function (s) { return s.b === FOCUS; });
    if (!mine.length) mine = STORES.slice(0, 1);
    var now = midnight(new Date()).getTime();
    var withEv = mine.filter(function (s) {
      return evs.some(function (e) { return e.h === s.h && midnight(e.ed).getTime() >= now; });
    });
    return (withEv[0] || mine[0]).h;
  }
  var loc = qs.get('loc') || '';
  if (loc.indexOf('b:') === 0) loc = '';           /* legacy brand-scope links */
  if (!STORES.some(function (s) { return s.h === loc; })) loc = defaultLoc();
  sel.value = loc;
  if (sel.value !== loc) { loc = defaultLoc(); sel.value = loc; }
  var today = midnight(new Date());
  var cur = new Date(today.getFullYear(), today.getMonth(), 1);
  var mh = (location.hash || '').match(/^#(\d{4})-(\d{2})$/);
  if (mh) cur = new Date(+mh[1], +mh[2] - 1, 1);

  function filtered() { return evs.filter(function (e) { return e.h === loc; }); }
  function onDay(e, d) { var t = d.getTime(); return t >= midnight(e.sd).getTime() && t <= midnight(e.ed).getTime(); }
  function accent(e) { return (BRANDS[e.b] || {}).c || '#2E5339'; }
  function fmtRange(e) {
    var a = e.sd, b = e.ed;
    var s = MS[a.getMonth()] + ' ' + a.getDate();
    if (midnight(a).getTime() === midnight(b).getTime()) return s + ', ' + a.getFullYear();
    var t = (a.getMonth() === b.getMonth() ? '' : MS[b.getMonth()] + ' ') + b.getDate();
    return s + '&ndash;' + t + ', ' + b.getFullYear();
  }
  function gcal(e) {
    function f(d) { return d.getUTCFullYear() + z(d.getUTCMonth() + 1) + z(d.getUTCDate()) + 'T' + z(d.getUTCHours()) + z(d.getUTCMinutes()) + '00Z'; }
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(e.t) +
      '&dates=' + f(e.gs) + '/' + f(e.ge) +
      '&details=' + encodeURIComponent((e.d || '').replace(/\n+/g, ' ')) +
      '&location=' + encodeURIComponent(e.disp || e.l);
  }

  /* ---- render ---- */
  var cal = document.getElementById('EvpCal');
  var agenda = document.getElementById('EvpAgenda');
  var empty = document.getElementById('EvpEmpty');
  var monEl = document.getElementById('EvpMon');
  var modal = document.getElementById('EvpModal');
  var mbody = document.getElementById('EvpMbody');
  var shown = [];

  function chip(e, idx) {
    return '<button type="button" class="evp-chip" data-i="' + idx + '" style="--evpc:' + accent(e) + '">' +
      '<span class="evp-cdot"></span><span class="evp-ct">' + esc(e.t) + '</span></button>';
  }

  function render() {
    var list = filtered();
    var y = cur.getFullYear(), m = cur.getMonth();
    monEl.textContent = MON[m] + ' ' + y;
    shown = list.filter(function (e) {
      return !(midnight(e.ed) < new Date(y, m, 1) || midnight(e.sd) > new Date(y, m + 1, 0));
    });

    var first = new Date(y, m, 1), start = new Date(y, m, 1 - first.getDay());
    var last = new Date(y, m + 1, 0);
    var cells = Math.ceil((last.getDate() + first.getDay()) / 7) * 7;
    var html = '';
    for (var c = 0; c < cells; c++) {
      var d = new Date(start.getFullYear(), start.getMonth(), start.getDate() + c);
      var out = d.getMonth() !== m, isToday = d.getTime() === today.getTime();
      var todays = shown.filter(function (e) { return onDay(e, d); });
      html += '<div class="evp-day' + (out ? ' is-out' : '') + (isToday ? ' is-today' : '') +
        (todays.length ? ' has-ev' : '') + '">' +
        '<span class="evp-dnum">' + d.getDate() + '</span>' +
        '<div class="evp-chips">' +
        todays.map(function (e) { return chip(e, shown.indexOf(e)); }).join('') +
        '</div></div>';
    }
    cal.innerHTML = html;

    /* agenda (mobile view + month summary) */
    var ag = shown.slice().sort(function (a, b) { return a.sd - b.sd; });
    agenda.innerHTML = ag.map(function (e) {
      return '<button type="button" class="evp-arow" data-i="' + shown.indexOf(e) + '" style="--evpc:' + accent(e) + '">' +
        '<span class="evp-ad"><b>' + MS[e.sd.getMonth()] + '</b><i>' + e.sd.getDate() + '</i></span>' +
        '<span class="evp-at"><b>' + esc(e.t) + '</b><i>' + esc(e.disp || e.l) +
        (MULTI ? ' &middot; ' + esc((BRANDS[e.b] || {}).n || '') : '') + '</i></span></button>';
    }).join('');

    if (!shown.length) {
      var name = (function () {
        var s = STORES.filter(function (x) { return x.h === loc; })[0];
        return s ? (s.d || s.l) : 'this location';
      })();
      var next = list.filter(function (e) { return midnight(e.sd) > last; })[0];
      empty.innerHTML = 'No events scheduled at ' + esc(name) + ' in ' + MON[m] + ' ' + y + '.' +
        (next ? ' <button type="button" class="evp-jump">Jump to ' + MON[next.sd.getMonth()] + ' ' + next.sd.getFullYear() + '</button>' : '');
      empty.hidden = false;
    } else { empty.hidden = true; }

    if (history.replaceState) {
      var q = '?loc=' + encodeURIComponent(loc);
      history.replaceState(null, '', location.pathname + q + '#' + y + '-' + z(m + 1));
    }
  }

  function openEv(i) {
    var e = shown[i]; if (!e) return;
    var paras = (e.d || '').split(/\n+/).filter(Boolean)
      .map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') || '';
    var st = e.st;
    var addr = st && st.st ? st.st + ', ' + st.c + ', ' + st.s + ' ' + st.z : '';
    var q = encodeURIComponent(addr || e.disp || e.l);
    var telHref = st && st.tel ? st.tel.replace(/[^+0-9]/g, '') : '';
    var telText = st && st.tel ? st.tel.replace(/^\+1-/, '').replace(/-/g, '.') : '';
    mbody.innerHTML =
      '<div class="evp-mbrand" style="--evpc:' + accent(e) + '">' +
      (MULTI ? esc((BRANDS[e.b] || {}).n || '') : '') + '</div>' +
      '<h2 class="evp-mt" id="EvpMt">' + esc(e.t) + '</h2>' +
      '<div class="evp-mmeta">' + fmtRange(e) + (e.ad ? ' &middot; All day' : '') + '</div>' +
      '<div class="evp-mcols">' +
        '<div class="evp-mmain">' +
          '<div class="evp-mdesc">' + (paras || '<p>Stop in and see us.</p>') + '</div>' +
          '<a class="dcta-evadd evp-madd" style="--bc:' + accent(e) + '" href="' + gcal(e) +
          '" target="_blank" rel="noopener">Add to calendar</a>' +
        '</div>' +
        '<div class="evp-mside">' +
          '<div class="evp-mstore">' +
            '<h3><a href="/pages/' + e.h + '">' + esc(e.disp || e.l) + '</a></h3>' +
            (addr ? '<p class="evp-maddr">' + esc(st.st) + '<br>' +
                    esc(st.c + ', ' + st.s + ' ' + st.z) + '</p>' : '') +
            (telHref ? '<p class="evp-mtel"><a href="tel:' + telHref + '">' + esc(telText) + '</a></p>' : '') +
            '<p class="evp-mlinks">' +
              '<a href="https://www.google.com/maps/dir/?api=1&destination=' + q +
              '" target="_blank" rel="noopener">Get directions</a>' +
              '<a href="/pages/' + e.h + '">Store page</a>' +
            '</p>' +
          '</div>' +
          '<iframe class="evp-mmap" loading="lazy" title="Map to ' + esc(e.disp || e.l) +
          '" src="https://www.google.com/maps?q=' + q + '&output=embed"></iframe>' +
        '</div>' +
      '</div>';
    modal.hidden = false;
    document.body.classList.add('evp-lock');
  }
  function closeEv() { modal.hidden = true; document.body.classList.remove('evp-lock'); }

  root.addEventListener('click', function (ev) {
    var c = ev.target.closest('.evp-chip, .evp-arow');
    if (c) { openEv(+c.getAttribute('data-i')); return; }
    if (ev.target.closest('.evp-jump')) {
      var list = filtered();
      var last = new Date(cur.getFullYear(), cur.getMonth() + 1, 0);
      var next = list.filter(function (e) { return midnight(e.sd) > last; })[0];
      if (next) { cur = new Date(next.sd.getFullYear(), next.sd.getMonth(), 1); render(); }
    }
  });
  modal.addEventListener('click', function (ev) { if (ev.target.closest('[data-evp-close]')) closeEv(); });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !modal.hidden) closeEv(); });

  document.getElementById('EvpPrev').addEventListener('click', function () { cur = new Date(cur.getFullYear(), cur.getMonth() - 1, 1); render(); });
  document.getElementById('EvpNext').addEventListener('click', function () { cur = new Date(cur.getFullYear(), cur.getMonth() + 1, 1); render(); });
  document.getElementById('EvpToday').addEventListener('click', function () { cur = new Date(today.getFullYear(), today.getMonth(), 1); render(); });
  sel.addEventListener('change', function () { loc = sel.value; render(); });

  render();
})();
